module.exports = "<p>\r\n    client works!\r\n</p>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/client/client.component.html
// module id = ./src/app/app_manager/app_element/client/client.component.html
// module chunks = main